<template>
  <div
    ref="textOutter"
    :class="options.verticalAlign && options.verticalAlign !== 'top' ? 'text-component height-auto' : 'text-component'"
    :style="getTextStyle"
    v-show="(getTextContent && getTextContent.length > 0) || options.isUserInfo || (request_prefix !==
    'bigScreen' && options.emptyDataShowLocal)"
  >
    <div :style="getTextControl">
      <el-scrollbar style="height: 100%" v-if="options.textOverFlowType == 'scroll' && !isTextAnimate">
        <div
          class="content"
          v-if="!options.animateSets || options.animateSets.animateType === 0"
          ref="textInner"
          :class="[
            options.contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLine' : '',
            linkUrlLength > 0 ? 'c-pointer' : ''
          ]"
          :style="getTextColor"
          @click.self="textClickEvent"
          :contenteditable="isEditStatu"
          v-html="getTextContent"
          @dblclick.self="dbEditContent($event)"
          @blur="dbChangeContent($event)"
        ></div>
      </el-scrollbar>
      <template v-else>
        <div
          class="content"
          v-if="!options.animateSets || options.animateSets.animateType === 0"
          ref="textInner"
          :class="[
            options.contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLine' : '',
            linkUrlLength > 0 ? 'c-pointer' : ''
          ]"
          :style="getTextColor"
          @click.self="textClickEvent"
          :contenteditable="isEditStatu"
          v-html="getTextContent"
          @dblclick.self="dbEditContent($event)"
          @blur="dbChangeContent($event)"
        ></div>
        <svg
          v-else-if="
            options.animateSets &&
            options.animateSets.animateType === 1 &&
            (options.animateSets.animateDirection === '横向' || options.animateSets.animateDirection === '无')
          "
          width="100%"
          :height="svgHeight"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs v-show="options.colorType === '线性渐变'">
            <linearGradient id="g3" x1="0%" y1="0%" x2=" 100%" y2="0">
              <stop offset="0%" :stop-color="options.endColor"></stop>
              <stop offset="100%" :stop-color="options.startColor"></stop>
            </linearGradient>
          </defs>
          <rect
            v-show="options.colorType === '线性渐变'"
            width="100"
            height="100%"
            x="0"
            y="100%"
            fill="url(#g3)"
          ></rect>
          <!-- <text>
          <tspan
            class="content"
            y="65%"
            font-weight="normal"
            :class="options.contentHasLimit ? 'overflowHidMultiLine' : ''"
            :style="'-webkit-line-clamp:' + options.textLimitLines"
            @click="textClickEvent"
            :fill="options.colorType === '线性渐变' ? 'url(#g3)' : options.color"
          >
            {{ editContent }}
          </tspan>
          <animate
            attributeName="x"
            :dur="options.animateSets.animateDuration + options.animateSets.animateDelay + 's'"
            :keyTimes="keyTimes"
            values="100%;0;0;-100%"
            :repeatCount="options.animateSets.animateTriggerNumType === '单次触发' ? '' : 'indefinite'"
          ></animate>
        </text> -->
          <g>
            <foreignObject width="100%" height="100%" style="overflow: visible" x="0" y="0">
              <text ref="textScrollX" :style="getTextColor" style="white-space: nowrap">{{ editContent }}</text>
            </foreignObject>
            <animateTransform
              attributeName="transform"
              :dur="options.animateSets.animateDuration + options.animateSets.animateDelay + 's'"
              :keyTimes="keyTimes"
              type="translate"
              :values="animateValueX"
              :repeatCount="
                options.animateSets && options.animateSets.animateTriggerNumType === '单次触发' ? '' : 'indefinite'
              "
            ></animateTransform>
          </g>
        </svg>
        <svg
          v-if="
            options.animateSets &&
            options.animateSets.animateType === 1 &&
            options.animateSets.animateDirection === '纵向'
          "
          width="100%"
          :height="svgHeight"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs v-show="options.colorType === '线性渐变'">
            <linearGradient id="g3" x1="100%" y1="0%" x2=" 200%" y2="0">
              <stop offset="0%" :stop-color="options.endColor"></stop>
              <stop offset="100%" :stop-color="options.startColor"></stop>
            </linearGradient>
          </defs>
          <rect
            v-show="options.colorType === '线性渐变'"
            width="100"
            height="100%"
            x="0"
            y="100%"
            fill="url(#g3)"
          ></rect>
          <g>
            <foreignObject width="100%" height="100%" style="overflow: visible" x="0" y="0">
              <p
                ref="textScrollY"
                class="content"
                :class="options.contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLine' : ''"
                :style="getTextColor"
                v-html="getTextContent"
              ></p>
            </foreignObject>
            <animateTransform
              attributeName="transform"
              :dur="options.animateSets.animateDuration + options.animateSets.animateDelay + 's'"
              :keyTimes="keyTimesY"
              type="translate"
              form="0 0"
              :to="animationValueY"
              :repeatCount="
                options.animateSets && options.animateSets.animateTriggerNumType === '单次触发' ? '' : 'indefinite'
              "
            ></animateTransform>
          </g>
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
import { isSsrPage, mhxssEncodeFunc, spliceLinkUrl, isExist } from "utils/index"
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import dataRenderMixin from "materials/dataRenderMixin"
import {compareIds} from "utils/event/animate";

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  name: "cxtext",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    oldAppId:{
      type:String
    }
  },
  data() {
    return {
      reloadTimer: null,
      isEditStatu: false,
      activeIds: undefined,
      animateWidth: "",
      animateHeight: "",
      layoutMapping: false,
      outerHeight: 0,
      animationValueY:'',
      isFlag: false
    }
  },
  watch: {
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n && this.noCacheComponent) {
          this.updateData()
        }
      }
    },
    "options.emptyDataShowLocal": {
      deep: true,
      handler(n, o) {
        if (n !== o && this.noCacheComponent) {
          this.updateData()
        }
        if (n !== o && this.dataType === "3" && isExist(this.myid?.directionIndex)) {
          this.setClassifyData()
        }
      }
    },
    "options.emptyContent": {
      deep: true,
      handler(n, o) {
        if (this.options.emptyDataShowLocal && this.options.isEmptyData && n && this.noCacheComponent) {
          this.$changeOptionsEV(n, "content", false, null, this.ids)
        }
        if (this.dataType === "3" && isExist(this.myid?.directionIndex)) {
          this.setClassifyData()
        }
      }
    },
    "options.dynamicData": {
      handler(n, o) {
        if (n && n.length > 0) {
          this.updateDynamicData(this.getTextContent)
        }
      },
      deep: true
    },
    "options.content"(newVal,oldVal){
      this.$nextTick(()=>{
        this.getAnimationValueY()
      })
    },
    "ids":{
      deep:true,
      handler(n,o) {
        if(this.isEditStatu && !compareIds(n,this.myid)){
          this.dbChangeContent()
        }
      }
    },
    dataType(n, o) {
      if (n !== o && n === "3" && !this.isFlag) {
        if (isExist(this.myid?.directionIndex)) this.watchClassifyData()
        else this.watchSearchData()
      }
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
    // console.log('options',this.options)
    let appId = this.options.appId || this.oldAppId
    if(this.oldAppId && !this.options.appId){
      console.log("脏数据")
      // 目前oldAppId只处理了大屏中的文本组件的脏数据
      this.$changeOptionsEV(this.oldAppId, "appId", false, null, this.myid)
    }
    if (
      this.noCacheComponent &&
      ((!this.options?.filedMapping?.flag && appId) || this.options?.detailFieldMapping?.isChecked)
    ) {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
    if (this.$refs.textScrollY) {
      this.animateHeight = this.$refs.textScrollY.offsetHeight
    }
    if (this.$refs.textScrollX) {
      this.animateWidth = this.$refs.textScrollX.offsetWidth
    }
    this.$nextTick(()=>{
      this.outerHeight = this.$refs.textOutter?.clientHeight
      this.getAnimationValueY()
    })
  //   判断是否在自由布局内部，且自由布局用了外接数据源
    if(this.noCacheComponentLayout && this.isBigScreenPreview() && !this.options.showEditCacheValue){
      this.$changeOptionsEV("", "content", false, null, this.myid, true)
    }
    if (this.dataType === "3") {
      if (isExist(this.myid?.directionIndex)) this.watchClassifyData() // 侧边栏请求分类数据
      else this.watchSearchData()
    }
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  computed: {
    dataType() {
      // 3: 搜索数据
      return this.options.dataType
    },
    actualLineHeight() {
      if (this.options.lineHeightType === '%') {
        return this.options.fontSize * (this.options.lineHeight / 100)
      } else if(this.options.lineHeightType === 'normal'){
        // 由于此时取不到文本的实际行高，所以采用通常normal大约是1.2到1.5倍的字体大小规则，此时取最大值
        return  this.options.fontSize * 1.5
      } else return this.options.lineHeight
    },
    svgHeight() {
      if (this.options.verticalAlign && this.options.verticalAlign !== "top") {
        return this.actualLineHeight + "px"
      } else {
        return "100%"
      }
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    animateValue() {
      if (this.$refs.textScrollY) {
        this.animateHeight = this.$refs.textScrollY.offsetHeight
      }
      let height = this.options.height
      let endHeight = height
      this.animateHeight > height ? (endHeight = this.animateHeight) : ""
      // return `0 ${height}; 0 0; 0 0; 0 ${-endHeight}`
      //  改变竖直方向的动画轨迹，暂定这个效果 - 舒斐
      return `0 0; 0 -${endHeight/3}; 0 -${endHeight*2/3};0 -${endHeight}`
    },
    animateValueX() {
      if (this.$refs.textScrollX) {
        this.animateWidth = this.$refs.textScrollX.offsetWidth
      }
      let x = this.options.width
      let endWidth = x
      this.animateWidth > x ? (endWidth = this.animateWidth) : ""
      return `${x} 0; 0 0; 0 0; ${-endWidth} 0`
    },
    edtiColContent() {
      let content = this.getTextContent?.replace(/<[^>]+>/g, ",")
      let textArr = content.split(",")
      return textArr.filter(function (i) {
        return i && i.trim()
      })
    },
    textLimitWords() {
      return this.options.textLimitWords || 2
    },
    // 判断是否按字数限制
    contentHasLimitwords() {
      return this.options.contentHasLimit && this.options.contentHasLimitRadio == "字数"
    },
    editContent() {
      if (this.$refs.textScrollX) {
        this.animateWidth = this.$refs.textScrollX.offsetWidth
      }
      let content = this.getTextContent?.replace(/<[^>]+>/g, " ")
      return content?.replace(/&nbsp;/g, " ")
    },
    getTextContent() {
      if (this.options.isUserInfo) {
        let thisContent = this.getTextData()
        let data = this.contentHasLimitwords ? thisContent.substr(0, this.textLimitWords) :thisContent
        // 添加直接省略和添加省略号
        data = this.options.wordOmitType === "ellipsis" && thisContent.length > this.textLimitWords ? data+'...' :data
        // 对空格、<、>进行还原
        data = mhxssEncodeFunc(data, false)
        return data
      } else {
        let arrEntities ={ lt: "<", gt: ">", amp: "&", qquot: '"', quot: '"',nbsp:' ' }
        let content1 = this.options.content
        if(typeof content1 === "number"){
          content1 = content1 + ""
        }
        let content = content1?.replace(/&(lt|gt|amp|qquot|quot|nbsp);/gi, function (all, t) {
          return arrEntities[t]
        })
        if(typeof content === "undefined" || content === null){
          content = ""
        }
        if(typeof content === 'number' && !isNaN(content) ){
          content = content.toString()
        }
        let data = this.contentHasLimitwords
          ? content.substr(0, this.textLimitWords)
          : content
        // let data = this.contentHasLimitwords
        //   ? this.options.content.substr(0, this.textLimitWords)
        //   : this.options.content
        /*兼容值为0的情况*/
        if (data === 0 || typeof data === "number") {
          data = data + ""
        }
        // 添加直接省略和添加省略号
        data = this.options.wordOmitType === "ellipsis" && content.length > this.textLimitWords ? data+'...' :data
        // 对空格、<、>进行还原
        data = mhxssEncodeFunc(data, false)
        this.updateDynamicData(data)
        return data
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    keyTimes() {
      let stopStartTime, stopEndTime
      let t =
        this.options.animateSets.animateDelay /
        (this.options.animateSets.animateDuration + this.options.animateSets.animateDelay)
      stopStartTime = (1 - t) / 2
      stopEndTime = stopStartTime + t
      return "0;" + stopStartTime.toFixed(2) + ";" + stopEndTime.toFixed(2) + ";1"
    },
    keyTimesY() {
      let endHeight = this.options.height
      this.animateHeight > this.options.height ? (endHeight = this.animateHeight) : ""
      let start = this.options.height / (this.options.height + endHeight)
      let stopStartTime, stopEndTime
      let t =
        this.options.animateSets.animateDelay /
        (this.options.animateSets.animateDuration + this.options.animateSets.animateDelay)
      stopStartTime = (1 - t) * start
      stopEndTime = stopStartTime + t
      return "0;" + stopStartTime.toFixed(2) + ";" + stopEndTime.toFixed(2) + ";1"
    },
    bgColor() {
      switch (this.options.bgType) {
        case "主题色":
          return isSsrPage()
            ? this.$store.state.page.themeColor
            : this.$store.state[this.request_prefix].page.themeColor
        case "自定义":
          return this.options.bgColor
      }
    },
    hoverBgColor() {
      switch (this.options.hoverBgType) {
        case "主题色":
          return isSsrPage()
            ? this.$store.state.page.themeColor
            : this.$store.state[this.request_prefix].page.themeColor
        case "自定义":
          return this.options.hoverBgColor
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.options.background || !Array.isArray(this.options.background)) {
        return {}
      }
      let background1 = this.options.background
      if (this.onWarningStatus && this.warningBgColor) {
        background1 = this.warningBgColor
      }
      background1.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            if (bg.imgUrl) {
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
            }
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
          containerBg.backgroundColor = this.$parseColor(bg)
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundImage = this.setBorderColor(containerBg.backgroundColor,containerBg.backgroundImage)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      if (this.options.showBorder !== false && this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor)) {
        containerBg.backgroundClip = "padding-box,border-box"// 圆角裁切
        containerBg.backgroundOrigin = "padding-box,border-box"
      }
      return containerBg
    },
    getTextColor() {
      let colorStyle = {}
      let colorArr = this.checkAndSetPrimaryVal(this.options, "colorArr", "colorArr", "{}")
      let tmp = []
      let textIsThemeColor1  = colorArr?.themeColorId ? colorArr.isThemeColor : this.options.textIsThemeColor
      if (this.onWarningStatus) {
        textIsThemeColor1 = this.resultTextIsThemeColor
        if (this.resultColorArr && JSON.stringify(this.resultColorArr) !== "{}") {
          colorArr = this.resultColorArr
        }
      }
      if (textIsThemeColor1) {
        colorStyle = {
          color: this.$parseColor(colorArr, {
            isThemeColor: textIsThemeColor1
          }),
          "-webkit-line-clamp": this.options.textLimitLines
        }
      } else {
        if (!(JSON.stringify(colorArr) == "{}" || JSON.parse(JSON.stringify(colorArr)) == "{}")) {
          if (colorArr.label === "线性渐变") {
            //老数据兼容 有些colorArr.data.stops不是数组
            colorArr?.data?.stops?.length &&
              colorArr.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
            colorStyle = {
              color: "transparent",
              // backgroundImage: `-webkit-linear-gradient(${colorArr.data.angle}deg, ${tmp.join(",")})`,
              backgroundImage: this.$parseColor(colorArr),
              // background: "-webkit-linear-gradient(top, #FF0000, #00FF00)",
              "-webkit-background-clip": "text",
              "-webkit-line-clamp": this.options.textLimitLines
            }
          } else if (colorArr.label === "颜色") {
            //老数据兼容，有些colorArr.data.stops[0][0]会报错
            colorStyle = {
              color: this.$parseColor(colorArr, {
                isThemeColor: textIsThemeColor1
              }),
              "-webkit-line-clamp": this.options.textLimitLines
            }
          }
        } else {
          colorStyle = {
            color: this.$parseColor(colorArr, {
              isThemeColor: textIsThemeColor1
            }),
            "-webkit-line-clamp": this.options.textLimitLines
          }
        }
      }
      // if (this.options.colorType === "线性渐变") {
      //   colorStyle = {
      //     color: "transparent",
      //     backgroundImage: `-webkit-linear-gradient(${this.options.colorlinearGradientAngle}deg, ${this.options.startColor}, ${this.options.endColor})`,
      //     // background: "-webkit-linear-gradient(top, #FF0000, #00FF00)",
      //     "-webkit-background-clip": "text",
      //     "-webkit-line-clamp": this.options.textLimitLines
      //   }
      // } else {
      //   colorStyle = {
      //     color: this.options.textIsThemeColor ? this.themeColor : this.options.color,
      //     "-webkit-line-clamp": this.options.textLimitLines
      //   }
      // }
      if (this.options.emptyDataShowLocal && this.options.isEmptyData && this.options.emptyFontColor) {
        colorStyle = {
          // color: this.options.emptyFontColor
          color: this.$parseColor(this.options.emptyFontColor),
        }
      }
      return {...colorStyle, "text-decoration": this.options.textDecoration,
        "text-decoration-color": colorStyle.color}
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    textShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.textShadowH)) {
        this.options.textShadowH.forEach((item, index) => {
          if (index > 0) {
            // tmpStyle += ","
            tmpStyle += " "
          }
          tmpStyle += `drop-shadow(${this.options.textShadowH[index]}px ${this.options.textShadowV[index]}px ${this.options.textShadowBlur[index]}px ${this.$parseColor(this.options.textShadowColor[index])})`
        })
      } else {
        tmpStyle += `drop-shadow(${this.options.textShadowH}px ${this.options.textShadowV}px ${this.options.textShadowBlur}px ${this.$parseColor(this.options.textShadowColor)})`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getPositionStyle() {
      let translate = "",
        top = undefined,
        bottom = undefined,
        width = undefined,
        maxHeight = undefined
      const { verticalAlign, textPaddingTypeFlag, padding, paddingTop, paddingBottom, paddingLeft, paddingRight } =
        this.options
      switch (verticalAlign) {
        case "center":
          top = "50%"
          translate = "translateY(-50%)"
          width =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingLeft + paddingRight}px)`
          maxHeight =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingTop + paddingBottom}px)`
          break
        case "bottom":
          bottom = textPaddingTypeFlag === 1 ? `${padding}px` : `${paddingBottom}px`
          width =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingLeft + paddingRight}px)`
          maxHeight =
            textPaddingTypeFlag === 1 ? `calc(100% - ${2 * padding}px)` : `calc(100% - ${paddingTop + paddingBottom}px)`
          break
        default:
      }
      // debugger
      if (parseInt(this.actualLineHeight) > this.outerHeight && verticalAlign === "center") {
        maxHeight = `${this.actualLineHeight}px`
      }
      return {
        position: verticalAlign && verticalAlign !== "top" ? "absolute" : "",
        transform: translate,
        top,
        bottom,
        width,
        maxHeight
      }
    },
    getTextStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let fontFamily1 = this.options.fontFamily,
        fontSize1 = this.options.fontSize,
        fontWeight1 = this.options.fontWeight
      if (this.options.emptyDataShowLocal && this.options.isEmptyData) {
        if (this.options.emptyFontFamily) {
          fontFamily1 = this.options.emptyFontFamily
        }
        if (this.options.emptyFontSize) {
          fontSize1 = this.options.emptyFontSize
        }
        if (this.options.emptyFontWeight) {
          fontWeight1 = this.options.emptyFontWeight
        }
      }
      const lineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
          this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px"
      return {
        ...this.bgStyle,
        padding: this.getPaddingStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        transform: `rotate(${this.options.rotate}deg)`,
        "font-style": this.options.fontStyle,
        "font-Family": fontFamily1,
        "text-indent": this.options.textIndent,
        "font-size": fontSize1 + "px",
        "font-weight": fontWeight1,
        height: "100%",
        "line-height": lineHeight,
        "text-align": this.options.textAlign,
        "text-align-last": this.options.textAlign,
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "--letterSpacing":
          this.options.letterSpacingType === "%"
            ? "-" + this.options.letterSpacing / 100 + "em"
            : "-" + this.options.letterSpacing + "px",
        "z-index": this.options.zIndex,
        "border-style": this.options.borderStyle,
        "border-color": this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor) ? "transparent" :this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-width": this.options.showBorder !== false ? borderW : 0,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "filter": this.textShadowStyle
      }
    },
    isTextAnimate() {
      // 判断是否是文本跑马灯效果
      let defaultFlag = false
      if (this.options.animateSets && this.options.animateSets.animateType === 1) {
        defaultFlag = true
      }
      return defaultFlag
    },
    getTextControl() {
      let textoverflow = ""
      if (this.options.textOverFlowType == "scroll") {
        // textoverflow = "scroll"
        textoverflow = "hidden"
      } else {
        textoverflow = this.options.textOverFlowType
      }
      // 跑马灯效果下都设置为hidden
      if (this.isTextAnimate) {
        textoverflow = "hidden"
      }
      return {
        ...this.getPositionStyle,
        transform: `${this.getPositionStyle.transform}`,
        "overflow-y": textoverflow ? textoverflow : "hidden",
        "overflow-x": textoverflow === "visible" ? "unset" : "hidden"
      }
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    linkUrlLength() {
      return this.options.linkUrl.length
    },
    // 是否开启了预警状态 且 有条件数据
    onWarningStatus(){
      if (this.options.onWarning && this.options.dynamicData && this.options.dynamicData.length > 0) {
        return true
      }else{
        return false
      }
    },
    resultTextIsThemeColor: {
      get() {
        return this.options.resultTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resultTextIsThemeColor", false)
      }
    },
    resultColorArr: {
      get() {
        let color = this.options.resultColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        return {}
      },
      set(val) {
        this.$changeOptionsEV(val, "resultColorArr", false)
      }
    },
    warningBgColor: {
      get() {
        return this.options.warningBgColor || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgColor", false)
      }
    },
    noCacheComponentLayout() {
      // 在四边栏中 不控制
      if (!(this.ids?.uid || isExist(this.ids?.elementInSwiperId))) return false
      // 在中间内容区
      let rectAttr = this.layoutOptions
      let filedMapping = this.options && this.options.filedMapping && this.options.filedMapping.flag
      if (rectAttr && rectAttr.innerElement !== "emptyLayoutComponent" && rectAttr.innerElement !== "swiperComponent") return false
      else return filedMapping && rectAttr && rectAttr.noCacheComponent
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    filedMapping() {
      return this.options && this.options.filedMapping || {}
    },
    currentFiledMapping() {
      return this.options.currentFiledMapping || {}
    },
  },
  methods: {
    watchSearchData() {
      this.isFlag = true
      this.$eventBus.$on(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`, (data)=> {
        const { type, activeData } = data
        if (type === 0) {
          console.log('text activeData :>>',activeData);
          this.setSearchData(activeData)
        }
      })
    },
    watchClassifyData() {
      this.isFlag = true
      this.$eventBus.$on(`layout-classify-update-eventBus-${this.myid.container_id}-${this.myid.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`, (msg)=> {
        console.log('msg.data :>>',msg.data,this.myid.rect_id);
        this.setClassifyData(msg.data)
      })
    },
    setClassifyData(data) {
      let curData = data ? data : this.getClassifyData()
      if (!curData) {
        if (this.options.emptyDataShowLocal) {
          this.$changeOptionsEV(this.options.emptyContent, "content", false, null, this.myid, true)
        } else {
          if (this.request_prefix === "bigScreen") this.$changeOptionsEV("暂无数据", "content", false, null, this.myid, true)
          else this.$changeOptionsEV("", "content", false, null, this.myid, true)
        }
        this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
      }
      if (this.currentFiledMapping && this.currentFiledMapping.fieldFlag && curData) {
        this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
        const tempData = curData.find(item=>item.value === this.currentFiledMapping.fieldFlag)
        if (tempData) {
          const dataType = this.currentFiledMapping.dataType
          let tempDataValue = tempData.content
          if (dataType === "dataKey") {
            tempDataValue = tempData.label + "：" + tempData.content
          } else if (dataType === "dataName") {
            tempDataValue = tempData.label
          }
          if (this.options.emptyDataShowLocal) {
            tempDataValue = tempData.content ? tempDataValue : this.options.emptyContent
          }
          this.$changeOptionsEV(tempDataValue, "content", false, null, this.myid, true)
        }
      }
    },
    getAnimationValueY(){
      // 底部还剩20的时候则切换，避免出现整个空白
      const bottomMargin = 20
      let endHeight = this.options.height
      if(this.$el){
        endHeight = this.$el.getElementsByClassName("content")[0].offsetHeight
      }
      if(endHeight > this.options.height){
        endHeight = endHeight - this.options.height + bottomMargin
      }else{
        endHeight = endHeight/2
      }
      this.animationValueY =  `0 ${-endHeight}`
    },
    async updateData() {
      if(this.isBigScreenPreview() && !this.options.showEditCacheValue){
        this.$changeOptionsEV("", "content", false, null, this.myid, true)
      }
      this.updateNormalRect.call(this, data => {
        console.log("updateCb", data)
        if (typeof data === "string") {
          this.$changeOptionsEV(data, "content", false, null, this.myid, true)
        } else {
          // 如果首页绑定了字段匹配 不能获取第一个值
          if (
            !this.options.currentFiledMapping ||
            (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
          ) {
            /*大屏外接数据空数据展示位暂无数据*/
            if (data.length === 0) {
              if (this.options.emptyDataShowLocal) {
                this.$changeOptionsEV(this.options.emptyContent, "content", false, null, this.myid, true)
              } else {
                if (this.request_prefix === "bigScreen") this.$changeOptionsEV("暂无数据", "content", false, null, this.myid, true)
                else this.$changeOptionsEV("", "content", false, null, this.myid, true)
              }
              this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
            } else {
              this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
              if(data && data[0]){
                this.$changeOptionsEV(data[0][Object.keys(data[0])[0]].value, "content", false, null, this.myid, true)
              }
            }
          } else if (this.options.currentFiledMapping && this.options.currentFiledMapping.fieldFlag && data.length > 0) {
            this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
            if(data && data[0]){
              const dataType = this.options.currentFiledMapping.dataType
              let data1 = data[0][this.options.currentFiledMapping.fieldFlag]
              if(this.options.getDataCount){//兼容获取数据数量的情况
                data1 = data[0][0]
              }
              let tempDataValue = data1.value
              if (dataType === "dataKey") {
                tempDataValue = data1.key + "：" + data1.value
              } else if (dataType === "dataName") {
                tempDataValue = data1.key
              }
              this.$changeOptionsEV(tempDataValue, "content", false, null, this.myid, true)
            }
          } else if(data.length === 0){
            if (this.options.emptyDataShowLocal) {
              this.$changeOptionsEV(this.options.emptyContent, "content", false, null, this.myid, true)
            } else {
              if (this.request_prefix === "bigScreen") this.$changeOptionsEV("暂无数据", "content", false, null, this.myid, true)
              else this.$changeOptionsEV("", "content", false, null, this.myid, true)
            }
            this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
          }
        }
      })
    },
    getTextData() {
      let defaultPortrait = require("assets/images/default_portrait.png")
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.realname || ""
      }
      this.$API.getUserInfo().then(res => {
        if (res.data.code === 1) {
          let userInfo = {
            portrait: res.data.data.uid ? `https://photo.chaoxing.com/p/${res.data.data.uid}_80` : defaultPortrait,
            ...res.data.data
          }
          this.$store.commit("states/updateUserInfo", userInfo)
          return userInfo.realname || ""
        }
      })
    },
    textClickEvent: function () {
      // 预览页面使用
      if (!this.options.linkUrl) {
        return
      }
      if (this.request_prefix === "bigScreen") {
        if (!this.isBigScreenPreview()) {
          return
        } else if (this.options.linkLoading !== undefined && !this.options.linkLoading) {
          this.swiperButttonFunc()
          return
        }
      }
      if (this.request_prefix !== "bigScreen" && !isSsrPage()) {
        return
      }
      const spliceUrl = spliceLinkUrl(this)
      if (this.options.openBlankPage) {
        window.open(spliceUrl || this.options.linkUrl, "_blank")
      } else {
        window.location.href = spliceUrl || this.options.linkUrl
        let index = window.location.href.indexOf("#")
        let isInnerUrl =
          this.options.linkUrl.indexOf("http") === -1 && this.options.linkUrl.indexOf("//") !== 0 ? true : false
        if (this.options.linkUrl.slice(0, index) === window.location.href.slice(0, index) || isInnerUrl) {
          setTimeout(() => {
            window.location.reload()
          }, 100)
        }
        // setTimeout(() => {
        //   window.location.reload()
        // }, 100)
      }
    },
    dbEditContent() {
      if (this.isBigScreenPreview() || this.noCacheComponentLayout) {
        return
      }
      this.isEditStatu = true
      sessionStorage.setItem("isEditStatu", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      this.$nextTick(() => {
        this.getSelectPos()
      })
    },
    // 将光标移动到最后面
    getSelectPos() {
      let esrc = this.$refs.textInner
      let range = document.createRange()
      range.selectNodeContents(esrc)
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    dbChangeContent(event) {
      this.isEditStatu = false
      sessionStorage.removeItem("isEditStatu")
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.activeIds, flag: true })
      let getTextContent = event.target.innerHTML.replace(/<[^>]+>/g, "<br>").replace(/(<br>)*$/g, "")
      this.$changeOptionsEV(getTextContent, "content", false, undefined, this.activeIds)
    },
    // 点击文本执行大屏轮播页面切换
    swiperButttonFunc() {
      let linkUrlArr = this.options.linkUrl.split("/")
      let linkPageId = linkUrlArr[linkUrlArr.length - 1]
      let pageLists = this.$store.state.bigScreen.page.children
      pageLists.forEach((item, index) => {
        if (item.pageId == linkPageId) {
          this.buttonColtrol(index)
        }
      })
    },
    //控制轮播页底部按钮的显示数量
    buttonColtrol(index) {
      const els = document.getElementsByClassName("el-carousel__indicator")
      if (els.length) {
        els[index].click()
      }
    },
    // 警告数据
    updateDynamicData(contentValue) {
      if(!this.onWarningStatus){
        return
      }
      let list = this.options.warningFieldMappingList
      if(this.options.warningMappingFieldFlag && list && list.length > 1) {
        // 添加了预警字段
        list.find((listItem)=>{
          if(this.options.warningMappingFieldFlag === listItem.value){
            contentValue = listItem.content
          }
        })
      }
      this.getResultObj()
      // 遍历动态数据条件
      for (let i = 0; i < this.options.dynamicData.length; i++) {
        const dynamicDataItem = this.options.dynamicData[i]
        if(dynamicDataItem.contentType === "数值"){
          contentValue = Number(contentValue)
          switch (dynamicDataItem.condition) {
            case "等于":
              if (contentValue === Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "不等于":
              if (contentValue !== Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "大于等于":
              if (contentValue >= Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "小于等于":
              if (contentValue <= Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "大于":
              if (contentValue > Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "小于":
              if (contentValue < Number(dynamicDataItem.parameter)) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "介于":
              if (
                  contentValue > Number(dynamicDataItem.conditionRange[0]) &&
                  contentValue <= Number(dynamicDataItem.conditionRange[1])
              ) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
          }
        } else {
          switch (dynamicDataItem.condition) {
            case "等于":
              if (contentValue === dynamicDataItem.parameter) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
            case "不等于":
              if (contentValue !== dynamicDataItem.parameter) {
                this.getResultObj(dynamicDataItem)
                continue
              }
              break
          }
        }
      }
    },
    getResultObj(dynamicDataItem){
      if(dynamicDataItem){
        this.resultTextIsThemeColor = dynamicDataItem.resultTextIsThemeColor
        this.resultColorArr = dynamicDataItem.resultColorArr
        this.warningBgColor = dynamicDataItem.resultBackground
      }else{
        this.resultTextIsThemeColor = false
        this.resultColorArr = {}
        this.warningBgColor = ""
      }
    },
    setSearchData(data) {
      if (!data) return
      let value = data[this.filedMapping?.value] || ""
      const name = this.filedMapping?.value === "name" ? "名称" : this.filedMapping?.value === "des" ? "说明" : ""
      switch (this.filedMapping?.dataType) {
        case "dataKey":
          value = name + "：" + value
          break
        case "dataName":
          value = name
          break
      }
      if (this.options.emptyDataShowLocal) {
        value = data[this.filedMapping?.value] ? value : this.options.emptyContent
      }
      this.$changeOptionsEV(value, "content", false, null, this.myid, true)
    }
  },
  beforeDestroy() {
    this.$eventBus.$off(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`)
    this.$eventBus.$off(`layout-classify-update-eventBus-${this.myid.container_id}-${this.myid.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`)
  }
}
</script>

<style scoped>
.overflowHidMultiLines {
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.text-component {
  width: 100%;
  word-break: break-word;
}
.text-component > div {
  width: 100%;
  height: 100%;
  word-break: break-word;
}
.text-component.height-auto {
  position: relative;
}
.text-component.height-auto {
  height: 100% !important;
}
.text-component.height-auto > div {
  height: auto;
}

::-webkit-scrollbar {
  width: 8px;
}

/* //滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #eaecf1;
  border-radius: 3px;
}

.content:focus {
  outline: none;
}

.edit-content {
  width: 100%;
  height: 100%;
}

.edit-content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}

.c-pointer:hover {
  cursor: pointer;
}

.text-component ::v-deep .el-scrollbar__view {
  margin-bottom: 0;
}
/*.text-component .content::after {*/
/*  display: inline-block;*/
/*  content: "";*/
/*  margin-left: var(--letterSpacing);*/
/*}*/
.text-component .content {
  margin-right: var(--letterSpacing);
}
/*处理宽度不够，图片展示不全问题*/
.text-component ::v-deep img {
  width: 100% !important;
}
</style>
